// libs
import React, { useState } from 'react';

//component
import IOElement from 'shared/components/IOElement';

// styles
import { Container, Text, IconWrapper, Icon } from './styles';

//context
import { useWishlistContext } from 'shared/layouts/Wishlist/API/context';

const STRIP_TEXT =
  'Great News! Prices have dropped for one or more items since you wishlisted them.';

function PriceDropStrip() {
  const { isFetching } = useWishlistContext();
  const [showAnimation, setShowAnimation] = useState(false);

  if (isFetching) return null;

  return (
    <Container data-test="price-drop-strip">
      <IOElement onVisible={() => setShowAnimation(true)} once />
      {showAnimation && (
        <IconWrapper>
          <Icon />
        </IconWrapper>
      )}
      <Text>{STRIP_TEXT}</Text>
    </Container>
  );
}
export default PriceDropStrip;
